(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.ticking = false;
    this.latestScrollTop = 0;

    // deadband so it doesn't flip-flop at the trigger
    this.hysteresis = 16;

    this.isSmall = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.onResizeHandler = this.onResize.bind(this);
  }

  connectedCallback() {
    this.headerSection = document.getElementById('shopify-section-header');
    if (!this.headerSection) return;

    // inner <header class="header ...">
    this.headerEl = this.headerSection.querySelector('header');
    if (!this.headerEl) return;

    this.annSection = document.getElementById('shopify-section-announcement-bar');

    this.updateTrigger = () => {
      this.triggerPoint = this.annSection ? this.annSection.offsetHeight : 0;
    };

    this.updateTrigger();

    if ('ResizeObserver' in window && this.annSection) {
      this.ro = new ResizeObserver(() => this.updateTrigger());
      this.ro.observe(this.annSection);
    }

    window.addEventListener('resize', this.onResizeHandler, { passive: true });
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });

    this.processScroll(window.pageYOffset || document.documentElement.scrollTop);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.onResizeHandler);
    if (this.ro) this.ro.disconnect();
  }

  onResize() {
    this.updateTrigger();
    this.processScroll(window.pageYOffset || document.documentElement.scrollTop);
  }

  onScroll() {
    this.latestScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.ticking) return;
    this.ticking = true;

    requestAnimationFrame(() => {
      this.processScroll(this.latestScrollTop);
      this.ticking = false;
    });
  }

  processScroll(scrollTop) {
    const trigger = this.triggerPoint || 0;

    const onAt = trigger + this.hysteresis;
    const offAt = trigger - this.hysteresis;

    const shouldBeSmall = this.isSmall ? (scrollTop > offAt) : (scrollTop > onAt);

const annBar = document.querySelector('.announcement-bar');

if (shouldBeSmall && !this.isSmall) {
  this.isSmall = true;
  this.headerEl.classList.add('shopify-section-header-small');
  if (annBar) annBar.classList.add('is-floating');
}
else if (!shouldBeSmall && this.isSmall) {
  this.isSmall = false;
  this.headerEl.classList.remove('shopify-section-header-small');
  if (annBar) annBar.classList.remove('is-floating');
}
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
    window.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    const activeId = this.openedBy && this.openedBy.getAttribute('data-media-id');
    if (!activeId) return;

    this.querySelectorAll('[data-media-id]').forEach((el) => {
      if (el.getAttribute('data-media-id') !== activeId) {
        el.classList.remove('active');
      }
    });

    const activeMedia = this.querySelector(`[data-media-id="${activeId}"]`);
    if (!activeMedia) return;

    const activeMediaTemplate = activeMedia.querySelector('template');
    const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();

    const container = this.querySelector('[role="document"]');
    if (container) {
      container.scrollLeft = (activeMedia.offsetWidth - container.clientWidth) / 2;
    }

    if (
      activeMedia.nodeName === 'DEFERRED-MEDIA' &&
      activeMediaContent &&
      activeMediaContent.querySelector('.js-youtube')
    ) {
      activeMedia.loadContent();
    }
  }
}

customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

                // Custom - Remove product from recommendations if it exists inside the accessories
                // Array of string values to search for
                const valuesToCheck = productAccHandles;
                
                // Get the parent element by its ID
                const parentElement = document.querySelector("product-recommendations > ul");
                
                // Function to check if a value exists within an <li> element and remove it if found
                function doesValueExistInListAndRemove(element, value) {
                  const listItems = element.getElementsByTagName('li');
                  for (let i = 0; i < listItems.length; i++) {
                    const listItem = listItems[i];
                    if (listItem.getElementsByTagName('a')[0].href.includes(value)) {
                      // If the value is found, remove the <li> element
                      listItem.parentNode.removeChild(listItem);
                      return true;
                    }
                  }
                  return false;
                }
                
               // Check if each value exists in the parent element's <li> elements and remove the <li> if found
                valuesToCheck.forEach(value => {
                  doesValueExistInListAndRemove(parentElement, value);
                });
            
               $('img').bind('contextmenu', function(e){
                    return false;
               }); 
            
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);  

  } catch(e) { console.error(e); }
})();
})();
